module.exports = global["$"] = require("-!/var/www/html/node_modules/expose-loader/index.js?jQuery!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js-exposed
// module id = 24
// module chunks = 1